// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.withdrawal-cage-logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0;
}
.withdrawal-cage-logo-container .withdrawal-cage-logo {
  height: 70px;
  width: 150px;
  background-size: contain;
  background-repeat: no-repeat;
  margin-right: 10px;
}
.withdrawal-cage-logo-container .withdrawal-cage-logo-text {
  font-size: 20px;
  font-weight: bold;
  margin-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/cashier/withdraw/withdrawal-cage/withdrawal-cage.component.scss"],"names":[],"mappings":"AAAA;EAEI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AAAJ;AAEI;EACI,YAAA;EACA,YAAA;EACA,wBAAA;EACA,4BAAA;EACA,kBAAA;AAAR;AAGI;EACI,eAAA;EACA,iBAAA;EACA,iBAAA;AADR","sourcesContent":[".withdrawal-cage-logo-container {\r\n\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin: 10px 0;\r\n\r\n    .withdrawal-cage-logo {\r\n        height: 70px;\r\n        width: 150px;\r\n        background-size: contain;\r\n        background-repeat: no-repeat;\r\n        margin-right: 10px;\r\n    }\r\n\r\n    .withdrawal-cage-logo-text {\r\n        font-size: 20px;\r\n        font-weight: bold;\r\n        margin-left: 10px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
